var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createRemoteProvider, FlagsClient } from '@medable-platform/flags';
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Spinner } from 'libs.nucleus';
import { AuthContext } from 'libs.react_internal';
export const FeatureFlagsContext = createContext({
    isFeatureEnabled: () => false,
    areFlagsInitialized: false,
    getAllFeatureFlags: () => ({}),
});
export const FeatureFlagsProvider = ({ children }) => {
    const { entityId, isLoggedIn } = useContext(AuthContext);
    const [areFlagsInitialized, setAreFlagsInitialized] = useState(false);
    const [client, setClient] = useState(null);
    useEffect(() => {
        if (isLoggedIn && entityId) {
            setAreFlagsInitialized(false);
            const flagProvider = createRemoteProvider(`${process.env.MOM_SERVICE_ENDPOINT}/v1/entities/${entityId}/flags`);
            const newClient = new FlagsClient(flagProvider);
            setClient((prevClient) => {
                if (prevClient) {
                    prevClient.destroy();
                }
                return newClient;
            });
        }
    }, [entityId, isLoggedIn]);
    useEffect(() => {
        const initializeFlags = () => __awaiter(void 0, void 0, void 0, function* () {
            if (areFlagsInitialized || !client) {
                return;
            }
            try {
                yield client.initialize();
            }
            catch (error) {
                console.error('Error initializing flags', error);
            }
            finally {
                setAreFlagsInitialized(true);
            }
        });
        initializeFlags();
    }, [areFlagsInitialized, client]);
    const isFeatureEnabled = useCallback((flagName, context) => {
        if (!areFlagsInitialized) {
            return false;
        }
        return client.isEnabled(flagName, context);
    }, [areFlagsInitialized]);
    const getAllFeatureFlags = useCallback(() => {
        if (!areFlagsInitialized) {
            return {};
        }
        return client.getAllFlags();
    }, [areFlagsInitialized]);
    const providerValue = useMemo(() => {
        return {
            isFeatureEnabled,
            areFlagsInitialized,
            getAllFeatureFlags,
        };
    }, [areFlagsInitialized, isFeatureEnabled, getAllFeatureFlags]);
    return !isLoggedIn || areFlagsInitialized ? (_jsx(FeatureFlagsContext.Provider, { value: providerValue, children: children })) : (_jsx(Spinner, { wrapper: 'full' }));
};
